import {ReactNode} from "react";
import PlanDTO from "../../../Models/DTOs/Plan";
import {useSignupQuote} from "../../../Hooks/Stripe/useSignupQuote";
import {formatMoney} from "../../../Helpers/Currency/Currency";
import {getOfferRenewalText, getResolvedOffer} from "../../../Helpers/BillingOffers";
import "./SignupAffiliatePlanPrice.scss";

export interface SignupAffiliatePricing {
    affiliateCode?: string;
    userId?: string;
    getValidAccessToken: () => Promise<string | null>;
}

interface Props {
    plan: PlanDTO;
    pricing: SignupAffiliatePricing;
    children: ReactNode;
}

/** Quote each signup option without changing the catalog offer used for checkout. */
export default function SignupAffiliatePlanPrice({plan, pricing, children}: Props) {
    const {quote, loading, error, retry} = useSignupQuote({plan, ...pricing});
    const eligibleQuote = quote?.affiliate_eligible ? quote : null;
    const renewalText = getOfferRenewalText(getResolvedOffer(plan));

    return (
        <div className="signup-affiliate-plan" role="group" aria-label={plan.title + " affiliate pricing"} aria-live="polite">
            {eligibleQuote && <>
                <h3 className="signup-affiliate-plan__first-price">
                    <span className="plan-selector__highlighted-price">{formatMoney(eligibleQuote.amount_due_minor, eligibleQuote.currency)}</span>{" "}
                    on your first invoice
                    {renewalText && <span className="plan-selector__small-price">{renewalText}</span>}
                </h3>
                <p className="signup-affiliate-plan__discount free-view-content-item-label">
                    <strong>Extra 10% affiliate discount applied</strong>
                </p>
            </>}
            {!eligibleQuote && children}
            {loading && <p className="signup-affiliate-plan__status">Checking affiliate discount...</p>}
            {error && <div className="signup-affiliate-plan__status">
                <p role="alert">Your affiliate price could not be confirmed. The current offer is shown above.</p>
                <button type="button" onClick={event => {
                    event.stopPropagation();
                    retry();
                }}>Retry affiliate price</button>
            </div>}
        </div>
    );
}
